import React from 'react';
import $ from 'jquery';

import {
    Form, Icon, Input, Button, Checkbox, Card
} from 'antd';

import {
    Link
} from 'react-router-dom';

import './App.css';
import config from './config.json';

const FormItem = Form.Item;

export default class Test extends React.Component {

    state = {
        result: "",
        getid: 0,
        classname:"gargablarg"
    }

    render() {
        const classdata = {
            "Id": 0, "CategoryId": 0, "ClassTypeId": 0,
            "Name": this.state.classname,
            "StartDate": "2017-01-01T00:00:00",
            "EndDate": "2018-01-01T00:00:00",
            "Venue": "wherever", "Address": "ndsu",
            "Cost": 9000.1, "Capacity": 1
        };

        return (
        <div>
                <h1>This is test, there are many like it but this one is mine.</h1>
                <pre>{JSON.stringify(classdata)}</pre>

                <div>classname</div>
                <Input name="classname" value={this.state.classname} onChange={({target}) => { this.setState({ classname: target.value }); }} />
                <Button onClick={() => { this.onclickpost(classdata) }}>Test post</Button>

                <div>id</div>
                <Input name="getid" type="number" value={this.state.getid} onChange={({target}) => { this.setState({ getid: target.value }); }} />
                <Button onClick={this.onclickget}> Test get</Button>

                <br />
                <div>result:</div>
                <br />
                <pre>
                    {this.state.result}
                </pre>

                {/* Testing the drop down stuff */}

            </div>);
    }

    componentDidMount()
    {
        // Get some dropdowns example.
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/dropdown/getdropdown`,
            data: { "DropdownName": "ClassCategory", "DropdownDataColumns": [ "CategoryName" ]}
        })
        .done((data) => {
            console.log('got the data!');
            console.log(data);
        })
        .fail((jqXhr) => {
            console.log('failed to get data');
        });
    }

    onclickget = (e) => {
        console.log(`clicked ${this.state.getid} ${config.serverUrl}`);

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/classes/get/${this.state.getid}`
        })
            .done((data) => {
                console.log(data);
            console.log('got the data!');
        })
        .fail((jqXhr) => {
            console.log('failed to get data');
        });
    }

    onclickpost(data) {
        console.log(`posting data`);
        console.log(data);
        
        // Submit form via jQuery/AJAX
        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/classes/add`,
            data: data
        })
        .done((data) => {
            console.log('added a class!');
        })
        .fail((jqXhr) => {
            console.log('failed to register');
        });
    }
}


// WEBPACK FOOTER //
// ./src/Test.js